// TODO: This file needs to be migrated to a `en.json`

export const i18n = {
    infoAction: 'Click to edit',
    nonEditableTitle: 'Edit title text',
    nonEditableDescription: 'Edit description text',
};
